const EN = {
  Lang: {
    Code: "EN",
    TextEN: "English",
    TextVN: "Vietnamese",
  },
  Login: {
    ErrorEmail: "Please enter email",
    LoginDescription: "Enter your email and password to login",
    ButtonText: "Login",
  },
  hero: {
    title: "Your All-in-One AI Tool",
    description: "Translate text and files quickly with advanced AI technology",
  },

  tabs: {
    translate: "Text Translation",
    file: "File Translation",
    compress: "Image Compression",
  },

  file: {
    section_title: "File Translation",
    section_description:
      "Upload a file and translate the entire content into another language",
    from_language: "Source Language",
    to_language: "Target Language",
    drag_text: "Drag and drop your file here or",
    choose_file: "Choose file",
    support_text: "Supports DOC, DOCX, XLSX, PPTX, PDF ",
    translating: "Translating document...",
    translating_short: "📄 Translating",
    translating_short_complete: "📄 Translating the entire document.",
    reading_file: "Reading document...",
    translate_now: "Translate Now",
    downloadUrlNotFound: "File URL not found",
    character_limit_warning:
      "The file contains {{current}} characters, exceeding the {{limit}} characters allowed for free translation.",
  },

  note: {
    review_note_before: "Note: You have",
    review_note_after: "free document translations left today.",
    line1: "● Supports multiple formats: Word, Excel, PPTX...",
    line2:
      "● Keeps original layout, tables, and images. Preview before payment.",
    line3: "● Supports many popular and specialized languages",
    line4: "● Fast processing, easy to use, no technical skills required.",
    line5: "● Translation history available for download anytime.",
    warning:
      "* Note: After translation, text length may vary from the original layout. Please adjust fonts if necessary.",
  },

  preview: {
    title: "📄 Document Preview",
    note: "Pay now to download the full translated version.",
    choose_payment_method: "Choose a payment method",
    payment: "Pay",
    download: "Download",
    must_pay: "Please complete payment before downloading",
    loading_title: "Preparing preview...",
    loading_desc: "AI is rendering your document. Please wait a moment.",
  },

  feature: {
    format: {
      title: "Multiple Formats",
      desc: "Supports PDF, Word, TXT",
    },
    security: {
      title: "Secure",
      desc: "Files are securely encrypted",
    },
    layout: {
      title: "Preserve Layout",
      desc: "Maintain original formatting",
    },
  },

  auth: {
    login_required: "Please login to use this feature!",
    loginSuccess: "Login successful",
    loginFailed: "❌ Login failed",
  },

  error: {
    upload_fail: "❌ Failed to upload file",
    unsupported_format: "❌ Unsupported file format",
    translate_fail:
      "❌ An error occurred while translating the file. Please try again.",
    qr_fail: "❌ Failed to get payment QR code",
  },
  pdf: {
    selectPdfProcessingModeBeforeStart:
      "Please select a processing mode for the PDF file before starting the translation.",
    selectPdfTranslationMode: "Select PDF translation mode",
    only_text: {
      title: "Translate text only and keep the original images",
      desc: "Preserve the original PDF layout and replace only the text content.",
    },
    text_or_image: {
      title: "Translate Text and Images",
      desc: "Translate both text and any text contained within images.",
    },
    full_image: {
      title: "Export as Image-based PDF",
      desc: "Generate the translated PDF as image pages.",
    },
  },
  common: {
    close: "Close",
    loading: "Loading...",
    noData: "No data",
    ok: "Ok",
    delete: "Delete",
  },
  menu: {
    home: "Home",
    blog: "Blog",
    faq: "Faq",
  },

  user: {
    transactionHistory: "Transaction history",
    logout: "Logout",
  },

  blog: {
    notFound: "Blog not found",
    relatedPosts: "Related posts",
    authorAdmin: "Admin",
    pageTitle: "Blog & Insights",
    pageDescription: "Knowledge, guides and latest updates about AI Tools",
    noMorePosts: "All posts have been displayed",
  },

  seo: {
    blogTitleFallback: "Online document translation | MikoTech",
    blogDescriptionFallback:
      "Fast, accurate, secure document translation. Supports PDF, Word, Excel, PPT, images.",
    blogKeywordsFallback:
      "document translation, translate pdf, english translation",
  },
  payment: {
    complete: {
      title: "Paid file information",
    },

    fileName: "File name",
    fileSize: "File size",
    translateFrom: "Translate",
    paymentStatus: "Payment",

    paid: "Paid",
    unpaid: "Unpaid",

    download: "Download",
    transactionNotFound: "Transaction not found",
    expirationDate: "Expiration Date",
    createFailed: "Failed to create payment",
    paypalSuccess: "PayPal payment successful",
  },
  transaction: {
    title: "Transaction history",
    note: "List of uploaded files. You can pay or download the translated file after payment.",
    fileDeleted: "File deleted",
    notiteDeleteFile: "Are you sure you want to delete this file?",
    searchPlaceholder: "Search by file name...",

    table: {
      fileName: "File name",
      fileSize: "File size",
      language: "Language",
      status: "Status",
      price: "Price",
      action: "Action",
      expirationDate: "Expiration Date",
    },

    status: {
      all: "All status",
      paid: "Paid",
      unpaid: "Unpaid",
      free: "Free",
    },
    delete: "Delete",
    download: "Download",
    pay: "Pay",
    mustPayFirst: "Please complete payment before downloading",
    getQrFail: "Failed to get payment QR code",
  },

  pagination: {
    prev: "Prev",
    next: "Next",
  },
  faq: {
    title: "Frequently asked questions",
    description:
      "Want to learn more about the document translation service? Check the answers below.",
  },
  translate: {
    terms:
      "By continuing, I confirm that I agree to the platform's <termsLink>terms and policies</termsLink> and accept full responsibility for any translation I perform.",
    selectTone: "Select Translation Tone",
    analyzing_document: "Analyzing document...",
    extracting_content: "Extracting content...",
    ai_translating: "Translating with AI...",
    rebuilding_layout: "Rebuilding layout...",
    finalizing_document: "Finalizing document...",
    ai_processing:
      "Processing the document. The process will continue automatically until it is complete.",
    NotitePdf:
      "The PDF file currently only supports translating textual content and cannot preserve the original formatting. The output will be a file containing the translated content in plain text format.",
  },
  translation: {
    fileRetentionNotice:
      "Note: Your file will be automatically deleted after 30 days.",
    keepThisPageOpen:
      "Please keep this page open. Once the translation is complete, the system will automatically close the processing screen and open the preview.",
    emailNotice:
      "When the document translation is completed, the system will send you an email notification.",
    processing: "Processing",
    cancelTranslation: "Cancel translation",
    cancelling: "Cancelling...",
    cancelled: "The file translation has been cancelled.",
    cancelFailed: "Unable to cancel the translation. Please try again.",
  },
  footer: {
    productOf: "© 2026. A product of Miko Tech",

    description:
      "An AI-powered online document translation platform that helps process files quickly, easily, and securely.",
    badge: "AI Translation Platform",
    contactTitle: "Contact information",
    supportTitle: "Support policies",

    copyright: "© 2026 Docme.vn. A product of Miko Tech.",
    terms: "Terms",
    privacy: "Privacy",

    supportLinks: {
      termsAndPolicies: "Policies & Terms of Use",
      paymentPolicy: "Payment policy",
      privacyPolicy: "Privacy policy",
      userGuide: "User guide",
      contactInfo: "Contact information",
    },
  },
  fileSizeModal: {
    title: "File exceeds the allowed size limit",
    heading: "File size is too large",
    descBefore: "The file you selected is",
    descAfter: "The system only supports files up to",
    confirm: "I understand",
  },
  address:
    "4B Floor, 485B Nguyen Dinh Chieu Street, Ban Co Ward, Ho Chi Minh City, Vietnam",
  discount: {
    invalidCode: "The discount code is invalid or has expired.",
    alreadyUsed: "This discount code has already been used.",
    applySuccess: "The discount code was applied successfully.",
    rollbackSuccess: "The discount code was removed successfully.",
    placeholder: "Enter discount code",
  },
  bottomMarquee: {
    text: "🎉 Enter code <strong>DOCME50</strong> to get <strong>50% off</strong> your first document translation fee. Valid until 30/08.",
  },
  translationMode: {
    title: "Choose Translation Mode",
    free: {
      title: "Standard (Free)",
      short: "Standard (Free)",
      desc: "Suitable for regular documents, with fast processing",
    },
    paid: {
      title: "Advanced (Paid)",
      short: "Advanced (Paid)",
      desc: "More natural, accurate translations that better match the context",
    },
  },
  characterLimitModal: {
    title: "Free translation limit exceeded",
    heading: "File exceeds 30,000 characters",
    descBefore: "Your file contains",
    characters: "characters",
    descAfter:
      "which exceeds the 30,000-character limit for free translation. The system has automatically switched this file to paid translation mode.",
    confirm: "Got it",
  },
};

export default EN;
